import React from 'react';
import { ProviderMatchProviderLocationV9 } from '@kyruus/types';
import { messages, getLocationNameId } from '@kyruus/provider-components';
import { useIntl } from '@kyruus/intl';
import { LocationInfoItem, LocationPhoneAnchor } from './styles';
import { getContactDetails } from './utils';

const itemPropMap: { [key: string]: string } = {
  phone: 'telephone',
  fax: 'faxNumber',
  email: 'email'
};

interface ProviderContactProps {
  location: ProviderMatchProviderLocationV9;
  contactType: 'phone' | 'fax' | 'email';
}

const ProviderContact = ({
  location,
  contactType
}: ProviderContactProps): React.ReactElement => {
  const intl = useIntl();
  const contactDetails = getContactDetails(location, contactType);
  const locationId = location.primary_marketable_location_id || location.id;

  if (contactType === 'phone') {
    const locationNameId = getLocationNameId(location);
    const locationPhoneLabelId = `location-phone-label-${locationId}`;
    const locationPhoneId = `location-phone-${locationId}`;
    const locationPhoneAriaLabelledBy = `${locationNameId} ${locationPhoneLabelId} ${locationPhoneId}`;
    return (
      <li>
        <LocationInfoItem>
          <span
            id={locationPhoneLabelId}
            className={'contact-label'}
          >{`${intl.formatMessage(messages.phone)}: `}</span>
          <LocationPhoneAnchor
            id={locationPhoneId}
            aria-labelledby={locationPhoneAriaLabelledBy}
            data-testid="phoneLink"
            href={`tel:${contactDetails}`}
          >
            <span itemProp={itemPropMap.phone}>{contactDetails}</span>
          </LocationPhoneAnchor>
        </LocationInfoItem>
      </li>
    );
  } else {
    const label = messages[contactType]
      ? intl.formatMessage(messages[contactType])
      : contactType;
    return (
      <>
        {contactDetails && (
          <li>
            <LocationInfoItem>
              <span className={'contact-label'}>{`${label}: `}</span>
              <span itemProp={itemPropMap[contactType]}>{contactDetails}</span>
            </LocationInfoItem>
          </li>
        )}
      </>
    );
  }
};

export default ProviderContact;
